import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import {
  assignStudentRole,
  assignStudentOffice,
} from "../../../../actions/student.action";
import DropDownInput from "../../../DropDownInput";

const RoleComponent = ({ description, handleChange, dropDown }) => {
  return (
    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-center">
      <Dialog.Title
        as="h3"
        className="text-lg leading-6 font-medium text-gray-900"
      >
        Select Role
      </Dialog.Title>
      <div className="mt-2">
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <DropDownInput list={dropDown} handleChange={(e) => handleChange(e)} />
    </div>
  );
};

const OfficeComponent = ({
  description,
  dropDown,
  officeType,
  setOfficeType,
  setExecutiveType,
  setBoardOfTrusteeType,
}) => {
  console.log({ officeType });

  const executiveList = [
    { name: "President", value: "PRESIDENT" },
    { name: "Secretary", value: "SECRETARY" },
    { name: "Treasurer", value: "TREASURER" },
  ];

  const botList = [
    { name: "Chairman", value: "CHAIRMAN" },
    { name: "Board of Trustee", value: "BOARD_OF_TRUSTEE" },
  ];
  return (
    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-center">
      <Dialog.Title
        as="h3"
        className="text-lg leading-6 font-medium text-gray-900"
      >
        Select Office
      </Dialog.Title>
      <div className="mt-2">
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <DropDownInput
        list={dropDown}
        handleChange={(e) => setOfficeType(e.target.value)}
      />
      {officeType === "EXECUTIVE" && (
        <DropDownInput
          list={executiveList}
          handleChange={(e) => setExecutiveType(e.target.value)}
        />
      )}
      {officeType === "BOARD_OF_TRUSTEE" && (
        <DropDownInput
          list={botList}
          handleChange={(e) => setBoardOfTrusteeType(e.target.value)}
        />
      )}
    </div>
  );
};

export default function AssignRoleModal({
  open,
  setOpen,
  cancelButtonRef,
  handleRoleSubmit,
  user,
  header,
  dropDown,
}) {
  const dispatch = useDispatch();
  const [role, setRole] = useState("");
  const [executiveType, setExecutiveType] = useState("");
  const [boardOfTrusteeType, setBoardOfTrusteeType] = useState("");
  const [chapterLeadLocation, setChapterLeadLocation] = useState("");
  const [officeType, setOfficeType] = useState("");
  const [description, setDescription] = useState(
    "Select and assign role to pathfinder."
  );

  const createPayload = (officeType) => {
    switch (officeType) {
      case "EXECUTIVE":
        var payload = {
          officeType,
          executiveType,
        };
        return payload;
      case "BOARD_OF_TRUSTEE":
        var payload = {
          officeType,
          boardOfTrusteeType,
        };
        return payload;
      default:
        break;
    }
  };
  const handleRole = () => {
    var id = user.id;
    var name = user.fullName;

    switch (header) {
      case "OFFICE":
        const officePayload = createPayload(officeType);
        dispatch(assignStudentOffice(id, officePayload));
        setOpen(false);
        break;
      case "ROLE":
        const payload = { id, name, role };
        dispatch(assignStudentRole(payload));
        setOpen(false);
        break;
      default:
        break;
    }
  };

  const handleOffice = (e) => {
    const value = e.target.value;
    setOfficeType(value);
  };

  const handleChange = (e) => {
    setRole(e.target.value);
    dropDown.map((role) => {
      if (role.value === role) {
        setDescription(role.desc);
      } else {
        setDescription("Select and assign role to pathfinder.");
      }
    });
  };

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:fle sm:items-star">
                      {header === "ROLE" && (
                        <RoleComponent
                          description={description}
                          handleChange={handleChange}
                          dropDown={dropDown}
                        />
                      )}

                      {header === "OFFICE" && (
                        <OfficeComponent
                          description={description}
                          handleChange={handleOffice}
                          dropDown={dropDown}
                          officeType={officeType}
                          setOfficeType={setOfficeType}
                          setExecutiveType={setExecutiveType}
                          setBoardOfTrusteeType={setBoardOfTrusteeType}
                        />
                      )}
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => handleRole()}
                    >
                      Assign
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
